/* app/js/src/components/common/alerts-notification-button/alerts-notification-button.component.scss */
.alerts-notification-button {
  width: 25px;
  height: 20px;
  margin-right: 12px;
}
.red-circle {
  position: absolute;
  z-index: 1;
  left: 13px;
  top: -8px;
  font-size: 11px;
  border-radius: 8px;
  min-width: 16px;
  background-color: #ef5350;
}
.red-circle .number {
  text-align: center;
  color: #ffffff;
}
/*# sourceMappingURL=alerts-notification-button.component.css.map */
